import script from "./PerfilesCompetidores.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilesCompetidores.vue?vue&type=script&setup=true&lang=js"

import "./PerfilesCompetidores.vue?vue&type=style&index=0&id=5ad106be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad106be"]])

export default __exports__